import "./App.css";
import React from "react";
import MyRoutes from "./routes";

function App() {
  return (
    <div className="App">
      <MyRoutes />
    </div>
  );
}

export default App;
